import { setOrderFinish } from "@/services";
import { toastError, toastSuccess } from "@/utils";
import { Toast } from "primereact";
import { useMutation, useQueryClient } from "react-query";

export const useSetOrderFinishData = (toast: React.RefObject<Toast>) => {
 const queryClient = useQueryClient();
 const { mutate: finishMutate } = useMutation(
  async (orderId: bigint) => await setOrderFinish(orderId),
  {
   onSuccess: () => {
    queryClient.invalidateQueries("orders");
    toastSuccess(toast, "Order set finish.");
   },
   onError: () => {
    toastError(toast, "Order not set finish.");
   },
  },
 );
 return {
  finishMutate,
 };
};
